import Tracker from "../prop-trackers/tracker.js";
import PropTracker from "../prop-trackers/prop-tracker.js";
import SinglePropChainTracker from "./single-prop-chain-tracker.js";

class PropChainTracker extends Tracker {
    constructor(evtCtx, userdata) {
        super();

        this._evtCtx = evtCtx;

        this._chainTracker = new SinglePropChainTracker(evtCtx);
        this._propTracker = new PropTracker(userdata);

        const needsUpdate = () => this.protected_needsUpdate();
        this._chainTracker.listenNeedsUpdate(needsUpdate);
        this._propTracker.listenNeedsUpdate(needsUpdate);
    }

    track(object, key) {
        this._chainTracker.track(object, key);
    }

    protected_startUpdate() {
        this._chainTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._propTracker.track(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        return this._propTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._propTracker.finishUpdate();
    }
}

export default PropChainTracker;
